module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-notice-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/company_notice"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Company Notice List')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Company Notice List')))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.goCcompanyNoticeNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('New Registration')))])])])]), _c('div', [(_vm.searchEnd && _vm.companyNoticeList.length > 0) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.companyNoticeList), function(companyNotice) {
    return _c('tr', [_c('td', [_c('a', {
      on: {
        "click": function($event) {
          _vm.goCompanyNoticeDetail(companyNotice.id)
        }
      }
    }, [_vm._v(_vm._s(companyNotice.notice_title))])]), _c('td', {
      class: _vm.getColor(companyNotice.notice_start_date, companyNotice.notice_end_date)
    }, [_vm._v(_vm._s(_vm.isReleaseStatus(companyNotice.notice_start_date, companyNotice.notice_end_date)))]), _c('td', [_vm._v(_vm._s(_vm.startDateFormat(companyNotice.notice_start_date)))]), _c('td', [_vm._v(_vm._s(_vm.endDateFormat(companyNotice.notice_end_date)))]), _c('td', [_vm._v(_vm._s(_vm.isSendMail(companyNotice.is_mail_delivery)))]), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-info btn-sm margin-right",
      on: {
        "click": function($event) {
          _vm.goCompanyNoticeEdit(companyNotice.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Edit')))]), _c('a', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.companyNoticeDelete(companyNotice.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  }))])])]), (_vm.nextExist) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default next-page-search-btn",
    on: {
      "click": function($event) {
        _vm.search(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Read More')))])])])]) : _vm._e()]) : _vm._e(), (_vm.searchEnd && _vm.companyNoticeList.length == 0) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("通達タイトル")]), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v("状態")]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("通達表示開始日")]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("通知期間終了日")]), _c('th', {
    staticClass: "col-sm-2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("メール配信有無")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55b328e6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/company-notice-list.pug
// module id = 848
// module chunks = 1